import Model, { attr } from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';

// Proto: provider_te_rito_nz.Connection.
export default class Connection extends Model {
  declare [Type]: 'te-rito/connection';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // refId is the unique Te Rito Ref ID.
  @attr('string', { defaultValue: '' })
  declare refId: string;

  // localId is the unique Te Rito Local ID, normally equivalent to the Hero School ID.
  @attr('string', { defaultValue: '' })
  declare localId: string;

  // schoolId is the school's unique Hero identifier.
  @attr('string', { defaultValue: '' })
  declare schoolId: string;

  // syncEnabled determines whether school can read data from Te Rito and
  // update the hero school's resources.
  @attr('boolean', { defaultValue: false })
  declare syncEnabled: boolean;
}
